import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class SupplierGroup<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: index */
  index?: number;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: level */
  level?: number;
  /** Alias: name */
  name?: string;
  /** Alias: updateTime */
  updateTime?: string;

  __typename?: string;
}

const fields: FieldDefinitions<SupplierGroup> = {
  id: {
    alias: 'code',
  },
  index: {
    alias: 'index',
  },
  insertTime: {
    alias: 'insertTime',
  },
  level: {
    alias: 'level',
  },
  name: {
    alias: 'name',
  },
  updateTime: {
    alias: 'updateTime',
  },
  __typename: {
    alias: '__typename',
  },
};

export const supplierGroupEntityDefinition: EntitiyDefinition<SupplierGroup> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'LieferantenGruppe',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
